// extracted by mini-css-extract-plugin
export default {"layout":"RequestsPage_layout__aYVeC","tabs":"RequestsPage_tabs__gG5Ag","table":"RequestsPage_table__zTQ8k","selectContainer":"RequestsPage_selectContainer__cHNKG"};